export default {
    msTitle: 'My subscription',
    msSubtitle: 'Review your plan, your usage and manage your add-ons',
    msTabPlan: 'My plan',
    msTabAddons: 'Add-ons',
    msTabChange: 'Change plan',
    msTabHistory: 'History',
    msTabNotifications: 'Notifications',

    msCurrentPlan: 'Current plan',
    msNoPlan: 'You do not have a plan assigned yet',
    msNoPlanHint: 'Contact the administrator to activate your subscription',
    msPrice: 'Price',
    msBillingMonthly: 'Monthly',
    msBillingYearly: 'Yearly',
    msTargetProfile: 'Profile',
    msCycleStart: 'Cycle start',
    msCycleEnd: 'Renews on',
    msIncludedModules: 'Included modules',
    msIncludedFeatures: 'Features',
    msNoModules: 'This plan has no configured modules',
    msUnlimited: 'Unlimited',
    msPendingRequestBanner: 'You have a plan change request pending approval',

    msUsageTitle: 'Current cycle usage',
    msUsageSubtitle: 'Usage of your quotas in the current period',
    msUsed: 'Used',
    msLimit: 'Limit',
    msRemaining: 'Remaining',
    msNearLimit: 'Near limit',
    msAtLimit: 'Limit reached',
    msUpTo: 'Up to',
    msMax: 'max per item',
    msPerParentHint: 'The limit is per item (asset, scope, target), not a total. This shows your fullest item.',
    msExceeded: 'Exceeded',
    msNoUsage: 'No usage data available',

    msAddonsTitle: 'Contracted add-ons',
    msAddonsSubtitle: 'Additional capacity on top of your plan',
    msContractAddon: 'Contract add-on',
    msCancelAddon: 'Cancel',
    msAddonQuantity: 'Quantity',
    msAddonMonthlyCost: 'Monthly cost',
    msAddonTotalCost: 'Total monthly cost',
    msAddonActiveSince: 'Active since',
    msNoAddons: 'You have no contracted add-ons',
    msSelectAddon: 'Select an add-on',
    msAddonModule: 'Module',
    msAddonAttribute: 'Attribute',
    msAddonUnitValue: 'Value per unit',
    msAddonPricePerUnit: 'Price per unit',
    msContract: 'Contract',
    msConfirmCancelAddon: 'Do you want to cancel this add-on?',
    msAddonContracted: 'Add-on contracted successfully',
    msAddonCancelled: 'Add-on cancelled',
    msAddonContractError: 'Error contracting the add-on',
    msAddonCancelError: 'Error cancelling the add-on',
    msCancelConflict: 'Current usage exceeds the resulting limit; it cannot be cancelled now',

    msChangeTitle: 'Request a plan change',
    msChangeSubtitle: 'Pick a new plan; your request will be reviewed by the administrator',
    msSelectNewPlan: 'New plan',
    msRequestChange: 'Request change',
    msChangeNotes: 'Notes (optional)',
    msPendingRequest: 'You already have a pending request',
    msChangeRequested: 'Change request submitted',
    msChangeError: 'Error requesting the plan change',
    msSamePlan: 'This is already your current plan',
    msUpgrade: 'Upgrade',
    msDowngrade: 'Downgrade',

    msHistoryTitle: 'Plan change history',
    msNoHistory: 'No plan changes recorded',
    msHistoryDate: 'Date',
    msHistoryFrom: 'Previous plan',
    msHistoryTo: 'New plan',
    msHistoryType: 'Type',
    msHistoryDetail: 'Detail',
    msTypeInitial: 'Initial',
    msTypeUpgrade: 'Upgrade',
    msTypeDowngrade: 'Downgrade',
    msTypeAddonContracted: 'Add-on contracted',
    msTypeAddonCancelled: 'Add-on cancelled',
    msFilterAll: 'All',
    msFilterPlan: 'Plans',
    msFilterAddon: 'Add-ons',
    msFilterFrom: 'From',
    msFilterTo: 'To',

    msNotificationsTitle: 'Usage notifications',
    msNoNotifications: 'You have no notifications',
    msNotifWarning: 'Usage near the limit',
    msNotifCritical: 'Critical usage',
    msNotifCycle: 'Cycle',
    msMarkRead: 'Mark as read',

    msLoadError: 'Error loading the information',
};
